import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  language: string;
  staticText: any = {
    we: {}
  };

  constructor() {
    let language: any = { title: 'English', value: 'en' };
    try {
      const stored = localStorage.getItem('language');
      if (stored) {
        const parsed = JSON.parse(stored);
        language = parsed && typeof parsed === 'object' ? parsed : { value: parsed };
      }
    } catch {
      language = { value: localStorage.getItem('language') || 'en' };
    }
    this.language = language.value;
    let langCode = language.value;
    if (langCode === 'jp') {

      langCode = 'ja';
    } else if (langCode === 'hrv') {
      langCode = 'hr';
    } else if (langCode === 'swv') {
      langCode = 'sv';
    }
  }

  parseLang(data: string) {
    const brand = sessionStorage.getItem('brand');
    try {
      const changedBrandName = data.replace(new RegExp('bpBrandName', 'g'), String(brand));
      return JSON.parse(changedBrandName);
    } catch (error) {
      return {};
    }
  }

  async fetchStaticText(): Promise<void> {
    try {
      const langMap: Record<string, string> = {
        jp: 'ja',
        hrv: 'hr',
        swv: 'sv'
      };

      let langCode = langMap[this.getLanguage] || this.getLanguage;

      const apiUrl = `${environment.CDN_URL}/lang/${langCode}`;
      const response = await this.getTexts(`${apiUrl}-custom-dev`);
      this.staticText = this.parseLang(String(response));
    } catch (error) {
      console.error('Error fetching or parsing static text:', error);
      throw error;
    }
  }

  async getTexts(url: string): Promise<string> {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.text();
    } catch (error) {
      console.error('Error fetching text');
      throw error;
    }
  }

  getStaticText() {
    return this.staticText;
  }

  get getLanguage() {
    try {
      const storedLang = localStorage.getItem('language');
      const parsedLang = storedLang ? JSON.parse(storedLang) : null;
      return parsedLang?.value || 'en';
    } catch (error) {
      return 'en';
    }
  }
}
